import { render } from "./ListWonButCancelledAuctions.vue?vue&type=template&id=23ebbbb4&scoped=true&ts=true"
import script from "./ListWonButCancelledAuctions.vue?vue&type=script&lang=ts"
export * from "./ListWonButCancelledAuctions.vue?vue&type=script&lang=ts"

import "./ListWonButCancelledAuctions.vue?vue&type=style&index=0&id=23ebbbb4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ebbbb4"]])

export default __exports__